/* eslint-disable*/
import VueStoreService from './VueStoreService';
const LoanService = {

    async getLoans(url,store){
        var resp = await VueStoreService.get("loans"+url, store)
        return resp;
    },

    //DETAIL
    async getLoanById(loan_id,store){
        var resp = await VueStoreService.get("loan-detail/"+loan_id, store)
        return resp;
    },
    async saveLoan(data,store){
        var resp = await VueStoreService.post("loan-detail",data,store)
        return resp;
    },

    async updateLoan(loan_id, data,store){
        var resp = await VueStoreService.patch("loan-detail/checkout/"+ loan_id, data, store)
        return resp;
    },

    async editUpdateLoan(loan_id, data,store){
        var resp = await VueStoreService.patch("loan-detail/"+ loan_id, data, store)
        return resp;
    },

    async validateLoan(loan_code,store){
        var resp = await VueStoreService.get("loan-detail/validate/"+loan_code, store)
        return resp;
    },

    async cancelLoan(loan_id, data, store){
        var resp = await VueStoreService.patch("loan-detail/cancelLoan/"+ loan_id, data, store)
        return resp;
    }

}

export default LoanService;